import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"


import { ref, computed } from 'vue'
import cosFooterButtonProps from '../cosFooterButton'
import { useRouter } from 'vue-router'
import { cloneDeep } from 'lodash-es'
import { layoutTags } from '@dc-platform/dc-interaction'
import { useI18n } from 'vue-i18n'

const __default__ = { name: 'CosFooterButton' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: cosFooterButtonProps(),
  emits: ['change', 'update:value', 'submit', 'goUpdate', 'goBack', 'reset', 'validate'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t } = useI18n()
const props = __props
const router = useRouter()
const emit = __emit
const handleBtn = ref(false)
const okTextComputed = computed(() => {
  if (props.okText) {
    return props.okText
  }
  if (props.disabled) {
    return t('btn.edit')
  }
  return t('btn.save')
})
const goBack = () => {
  if (location.hostname === 'localhost') {
    router.go(-1)
  } else {
    layoutTags.close()
  }
}
const goUpdate = () => {
  if (props.editUrl) {
    router.push(props.editUrl)
  }
  emit('goUpdate')
}
const handleReset = () => {
  const result: any = {
    ...cloneDeep(props.resetValue)
  }
  if (Array.isArray(props.value)) {
    emit('update:value', result)
    emit('reset', result)
  } else {
    for (const key in props.value) {
      if (result[key] === undefined) {
        result[key] = undefined
      }
    }
    emit('update:value', Object.assign(props.value, result))
    emit('reset', Object.assign(props.value, result))
  }
  setTimeout(() => {
    props.formRef?.clearValidate()
  })
}
const onSubmit = () => {
  handleBtn.value = true
  if (props.formRef) {
    props.formRef
      .validate()
      .then(async () => {
        emit('submit')
      })
      .catch((err: any) => {
        const { errorFields } = err
        props.formRef?.scrollToField(errorFields[0].name, {
          scrollMode: 'if-needed',
          block: 'center',
          inline: 'end'
        })
      })
  } else {
    emit('submit')
  }
  emit('validate')
}
__expose({
  handleReset
})

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_SellerButton = _resolveComponent("SellerButton")!
  const _component_dc_layout_button_group = _resolveComponent("dc-layout-button-group")!
  const _component_dc_layout_footer = _resolveComponent("dc-layout-footer")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_footer, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_button_group, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (goBack())),
            loading: _ctx.loading
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('btn.cancel')), 1)
            ]),
            _: 1
          }, 8, ["loading"]),
          (!props.disabled)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (handleReset())),
                loading: _ctx.loading
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('btn.reset')), 1)
                ]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default", {}, () => [
            (!_ctx.hideOk)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (props.disabled)
                    ? _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                        key: 0,
                        type: "primary",
                        workCode: _ctx.workCode,
                        controlType: "none",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (goUpdate())),
                        loading: _ctx.loading
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(okTextComputed.value), 1)
                        ]),
                        _: 1
                      }, 8, ["workCode", "loading"])), [
                        [_directive_permission, _ctx.permissionPage?.edit]
                      ])
                    : _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        key: 1,
                        type: "primary",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (onSubmit())),
                        loading: _ctx.loading
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(okTextComputed.value), 1)
                        ]),
                        _: 1
                      }, 8, ["loading"])), [
                        [_directive_permission, _ctx.permissionPage?.save]
                      ]),
                  (_ctx.againBtn)
                    ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        key: 2,
                        type: "primary",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (onSubmit())),
                        loading: _ctx.loading
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("保存并新建")
                        ]),
                        _: 1
                      }, 8, ["loading"])), [
                        [_directive_permission, _ctx.permissionPage?.save]
                      ])
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})